import { Snackbar } from '@mui/joy';
import {
  CheckCircle,
  Info as InfoIcon,
  Warning as WarningIcon,
  WarningCircle,
} from '@phosphor-icons/react';

import { Alert } from '~/components/ui/alert';

const toastSeverities = ['error', 'success', 'warning', 'info'] as const;
export type ToastSeverity = (typeof toastSeverities)[number];

const decorator: Record<ToastSeverity, JSX.Element> = {
  error: <WarningIcon />,
  success: <CheckCircle />,
  warning: <WarningCircle />,
  info: <InfoIcon />,
};

const colorBySeverity: Record<
  ToastSeverity,
  'danger' | 'success' | 'warning' | 'neutral'
> = {
  error: 'danger',
  success: 'success',
  warning: 'warning',
  info: 'neutral',
};

export default function ToastAlert({
  open,
  setOpen,
  message,
  severity,
  duration,
}: Readonly<{
  open: boolean;
  setOpen: (value: boolean) => void;
  message: string;
  severity: ToastSeverity;
  duration: number | undefined;
}>) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={duration ?? 2500}
      className='!p-0'
    >
      <Alert
        startDecorator={decorator[severity]}
        color={colorBySeverity[severity]}
        className='w-full'
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
